const DEFAULT_SIMILARITY_THRESHOLD = 0.48;

function normalizeVector(values) {
  const vector = Array.from(values || [], Number);
  const norm = Math.sqrt(vector.reduce((sum, value) => sum + value * value, 0));
  return norm > 0 ? vector.map(value => value / norm) : vector;
}

function cosineSimilarity(left, right) {
  if (!left?.length || left.length !== right?.length) return -1;
  return left.reduce((sum, value, index) => sum + value * right[index], 0);
}

function updateCentroid(cluster) {
  const dimensions = cluster.faces[0].embedding.length;
  const average = new Array(dimensions).fill(0);
  cluster.faces.forEach(face => face.embedding.forEach((value, index) => { average[index] += value; }));
  cluster.centroid = normalizeVector(average.map(value => value / cluster.faces.length));
}

function clusterFaces(faces, threshold = DEFAULT_SIMILARITY_THRESHOLD) {
  const clusters = [];
  (faces || []).forEach(face => {
    const normalizedFace = { ...face, embedding: normalizeVector(face.embedding) };
    let bestCluster = null;
    let bestScore = threshold;
    clusters.forEach(cluster => {
      if (cluster.faces.some(member => String(member.pictureId) === String(face.pictureId))) return;
      const score = cosineSimilarity(normalizedFace.embedding, cluster.centroid);
      if (score >= bestScore) {
        bestCluster = cluster;
        bestScore = score;
      }
    });
    if (!bestCluster) {
      clusters.push({ faces: [normalizedFace], centroid: normalizedFace.embedding });
      return;
    }
    bestCluster.faces.push(normalizedFace);
    updateCentroid(bestCluster);
  });

  return clusters
    .map(cluster => {
      const pictureIds = [...new Set(cluster.faces.map(face => String(face.pictureId)))];
      const representative = [...cluster.faces].sort((left, right) => (right.faceArea || 0) - (left.faceArea || 0))[0];
      return { ...cluster, pictureIds, photoCount: pictureIds.length, representative };
    })
    .sort((left, right) => right.photoCount - left.photoCount || right.faces.length - left.faces.length)
    .map((cluster, index) => ({ ...cluster, id: `person-${index + 1}`, label: `人物 ${index + 1}` }));
}

function serializePersonGroups(clusters, metadata = {}) {
  return {
    version: 1,
    model: 'sface-2021dec-int8',
    scannedAt: new Date().toISOString(),
    ...metadata,
    groups: (clusters || []).map(cluster => ({
      id: cluster.id,
      label: cluster.label,
      photoCount: cluster.photoCount,
      pictureIds: cluster.pictureIds,
      representative: {
        pictureId: cluster.representative.pictureId,
        faceIndex: cluster.representative.faceIndex,
        bounds: cluster.representative.bounds,
      },
      faces: cluster.faces.map(face => ({
        pictureId: face.pictureId,
        faceIndex: face.faceIndex,
        bounds: face.bounds,
      })),
    })),
  };
}

export { DEFAULT_SIMILARITY_THRESHOLD, clusterFaces, cosineSimilarity, normalizeVector, serializePersonGroups };
